import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../Context/AuthContext";

const useFormValidationForgotPassword = () => {
  const { userType } = useContext(AuthContext);
  const [email, setEmail] = useState("");
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const validateEmail = (email) => {
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    return emailRegex.test(email);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "email") {
      setEmail(value);
    }

    setError(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null)

    if (!validateEmail(email)) {
      setError("Invalid email address");
      return;
    }

    setIsLoading(true);

    try {
      let endpoint = "";
      if (userType === "Charterer") {
        endpoint = `${process.env.REACT_APP_SERVER_URL}/auth/forgotPassword/charterer`;
      } else if (userType === "Vessel Owner") {
        endpoint = `${process.env.REACT_APP_SERVER_URL}/auth/forgotPassword/vesselOwner`;
      }

      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      const resData = await response.json();

      if (!response.ok) {
        setError(resData.message);
        throw new Error(resData.message);
      }

      setSuccessMessage("Password reset email sent successfully.");
      setTimeout(() => {
        setSuccessMessage("");
        navigate("/Resetpassword");
      }, 3000);
    } catch (error) {
      console.error(error);
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    email,
    error,
    successMessage,
    isLoading,
    handleInputChange,
    handleSubmit,
  };
};

export default useFormValidationForgotPassword;